import { AccountUnsimplifier } from "./account_unsimplifier"
import { GroupUnsimplifier } from "./group_unsimplifier"
import { MediaAttachmentUnsimplifier } from "./media_attachment_unsimplifier"
import { StatusUnsimplifier } from "./status_unsimplifier"

const unsimplifyStatus = (s) => {
  try {
    return StatusUnsimplifier.unsimplify(s)
  } catch (e) {
    // console.error("Failed to unsimplify status:", e)
    return s
  }
}

const unsimplifyAccount = (a) => {
  try {
    return AccountUnsimplifier.unsimplify(a)
  } catch (e) {
    // console.error("Failed to unsimplify account:", e)
    return a
  }
}

const unsimplifyGroup = (g) => {
  try {
    return GroupUnsimplifier.unsimplify(g)
  } catch (e) {
    // console.error("Failed to unsimplify group:", e)
    return g
  }
}

const unsimplifyMediaAttachment = (ma) => {
  try {
    return MediaAttachmentUnsimplifier.unsimplify(ma)
  } catch (e) {
    return ma
  }
}


export const mapObjectsToStatuses = (data) => {
  // Unsimplify the data before creating lookup tables.
  try {
    data.s = data.s.map(unsimplifyStatus)
    data.a = data.a.map(unsimplifyAccount)
    data.g = data.g.map(unsimplifyGroup)
    data.ma = data.ma.map(unsimplifyMediaAttachment)
  } catch (e) {
    // console.log("Failed to map objects to statuses:", e)
  }

  // First, create lookup tables for related objects to make it efficient to reattach them.
  const accountLookup = createLookupTable(data.a, 'id')
  const groupLookup = createLookupTable(data.g, 'id')
  const pollLookup = createLookupTable(data.p, 'id')
  const statusContextLookup = createLookupTable(data.sc, 'id')
  const mediaAttachmentLookup = createLookupTable(data.ma, 'id')
  const previewCardLookup = createLookupTable(data.pc, 'id')
  const statusLookup = createLookupTable(data.s, 'id')

  try {
    // Now, iterate over the statuses and reattach related objects using the lookup tables.
    data.s = data.s.map((status) => {
      // set keys and defaults
      status.account = null
      status.reblog = null
      status.quote = null
      status.group = null
      status.status_context = null
      status.card = null
      status.poll = null
      status.media_attachments = null

      if (status.account_id) status.account = accountLookup[status.account_id]
      if (status.reblog_of_id) status.reblog = statusLookup[status.reblog_of_id]
      if (status.quote_of_id) status.quote = statusLookup[status.quote_of_id]
      if (status.group_id) status.group = groupLookup[status.group_id]
      if (status.status_context_id) status.status_context = statusContextLookup[status.status_context_id]
      if (status.preview_card_id) status.card = previewCardLookup[status.preview_card_id]
      if (status.poll_id) status.poll = pollLookup[status.poll_id]
      if (status.media_attachment_ids) {
        status.media_attachments = status.media_attachment_ids
            .map(id => mediaAttachmentLookup[id])
            .filter(attachment => attachment !== null && attachment !== undefined)
      }

      return status
    })

    const values = data.t.map((statusId) => {
      return data.s.find((is) => `${is.id}` === `${statusId}`)
    })
    return values
  } catch (e) {
    // console.log("Failed to process data statuses:", e)
    return []
  }
}

function createLookupTable(objectsArray, idField) {
  try {
    const lookup = {}
    objectsArray.forEach((obj) => {
      lookup[obj[idField]] = obj
    })
    return lookup
  } catch (e) {
    // console.log("Failed to create lookup table:", e)
    return {}
  }
}